// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"98920275","769":"88165ab4"}[chunkId] + ".chunk.js";
};